"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var isSupported = function isSupported() {
  if (window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB) return true;
  return false;
};
var _default = exports["default"] = isSupported;